import { jsx } from "react/jsx-runtime";
import {
  getNumberMaskedValue,
  useNumberMask
} from "@elliemae/ds-form-helpers-mask-hooks";
import { DSInputText } from "@elliemae/ds-form-input-text";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { Grid } from "@elliemae/ds-grid";
import { safeSum } from "@frontend/utils";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useFormState, useWatch } from "react-hook-form";
import { useFieldAutoSetValue } from "../utils/fieldAutoSetValue";
import { useFieldVisibilityAndDisability } from "../utils/fieldVisibilityAndDisability";
const TotalLoanAmount = ({
  renderedField,
  schemaForm,
  rules,
  id,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  type,
  ui,
  visible,
  disabled,
  disableCheck,
  visibleCheck,
  valueHandler,
  preview
}) => {
  const CURRENCY = {
    allowNegative: false,
    decimalPlaces: 2,
    prefix: "$"
  };
  const { isVisible } = useFieldVisibilityAndDisability({
    schemaForm,
    rules,
    visible,
    disabled,
    visibleCheck,
    disableCheck,
    preview
  });
  const { errors } = useFormState({ control: schemaForm.control });
  const errorMessage = _.get(errors, pathValue)?.message;
  const stringValue = String(renderedField?.value ?? "");
  const [value, setValue] = useState(
    getNumberMaskedValue(stringValue, CURRENCY)
  );
  const updateDisplayValue = (val) => {
    const sv = String(val ?? "");
    setValue(getNumberMaskedValue(sv, CURRENCY));
  };
  useEffect(() => {
    updateDisplayValue(renderedField?.value);
  }, [renderedField?.value]);
  useFieldAutoSetValue({
    schemaForm,
    rules,
    pathValue,
    valueHandler,
    preview,
    onAutoSet: updateDisplayValue
  });
  const inputProps = useNumberMask({
    valueSetter: setValue,
    ...CURRENCY
  });
  const [financedAmount, firstMortgageAmount] = useWatch({
    control: schemaForm.control,
    name: [
      "loanInformation.financedAmount",
      "loanInformation.firstMortgageAmount"
    ]
  });
  useEffect(() => {
    const ParsedLoanAmount = parseInt(firstMortgageAmount, 10) || 0;
    const ParsedFinancedAmount = parseInt(financedAmount, 10) || 0;
    const result = safeSum(ParsedLoanAmount, Math.floor(ParsedFinancedAmount));
    schemaForm.setValue(pathValue, result);
  }, [firstMortgageAmount, financedAmount]);
  return /* @__PURE__ */ jsx(Grid, { span: ui.col_size, style: { display: isVisible ? "block" : "none" }, children: /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      name,
      label,
      required,
      feedbackMessage,
      hasError: !!errors[id] || !!errorMessage,
      validationMessage: errors[id]?.message?.toString() || errorMessage,
      children: /* @__PURE__ */ jsx(
        DSInputText,
        {
          ...renderedField,
          "data-testid": "textbox",
          value,
          ...inputProps,
          disabled: true,
          id: pathValue,
          placeholder: "$0"
        }
      )
    }
  ) });
};
export {
  TotalLoanAmount
};
